export const Y_AXIS_MILESTONES = 5;

export const VISIBLE_BARS = 8;

export const BAR_WIDTH = 83; // px

export const GAP_WIDTH = 32; // px
